<template>
  <div>
    <!-- <current-path /> -->
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.QuestionsGroups") }}</v-toolbar-title>
      <v-spacer> </v-spacer>
      <v-btn @click="dialog = !dialog" class="primary">
        <v-icon>mdi-plus</v-icon>
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      @get_items="getItems"
      ref="table_ref"
      :headersName="headers"
      pathName="question-groups"
      class="table-row"
      dialogWidth="500"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">
          {{ item.name }}
        </td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="question-groups"
            :model-id="item.id"
            field="visible"
            v-model="item.is_visible"
            :validate="true"
          />
        </td>
        <td class="text-sm-center">
          <v-icon
            @click="handleShow(item, index)"
            :title="$t('icon.edit')"
            small
            >mdi-pencil</v-icon
          >
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
    <v-dialog v-model="dialog" max-width="700">
      <v-card>
        <v-card-title class="dialog_header">
          {{ formTitle }}
        </v-card-title>
        <v-card-text>
          <FormAction
            :dialog="dialog"
            :form="form"
            :v="$v"
            :isEdit="isEdit"
            :item="this.item"
            @on-submited="onSubmited"
            @on-locale-change="onLocaleChange"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import cookie from "js-cookie";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { ShowData } from "@/helpers/apiMethods";
export default {
  name: "QuestionsGroups",
  components: {
    FormAction: () => import("./formAction"),
  },

  data() {
    return {
      headers: ["name", "visible", "actions"],
      isEdit: false,
      loadingButton: false,
      items: [],
      item: {},
      itemIndex: null,
      locale: this.locale,
      dialog: false,
      form: {
        name: "",
        survey_id: "",
        is_visible: 0,
      },
    };
  },
  methods: {
    handleShowData() {
      ShowData({
        reqName: "question-groups",
        param: this.item.id,
        locale: this.locale,
      })
        .then((res) => {
          const { question_group } = res.data;
          this.form = question_group;
        })
        .catch((err) => console.log(err));
    },
    onLocaleChange(locale) {
      this.locale = locale;

      this.handleShowData();
    },
    onSubmited(data) {
      if (!this.itemIndex) {
        this.items.push(data);
      } else {
        this.$set(this.items, this.itemIndex, data);
      }
      this.dialog = !this.dialog;
    },
    getItems(items) {
      this.items = items;
    },
    handleOpenDialog() {
      this.$refs.table_ref.toggleDialog();
    },
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    handleShow(item, index) {
      this.isEdit = true;
      this.item = item;
      this.itemIndex = index;
      this.dialog = !this.dialog;
      this.handleShowData();
    },
    resetData() {
      this.form = {
        name: "",
        survey_id: "",
        is_visible: 0,
      };
      this.$v.form.$reset();
      this.locale = cookie.get("language");
      this.isEdit = false;
    },
  },
  computed: {
    formTitle() {
      if (!this.isEdit) {
        return this.$t("heading.create");
      } else {
        return this.$t("heading.edit");
      }
    },
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(255),
      },
      is_visible: {
        required,
      },
      survey_id: {
        required,
      },
    },
  },
  watch: {
    dialog: {
      handler(value) {
        if (!value) {
          this.itemIndex = null;
          this.resetData();
        }
      },
      immediate: true,
    },
  },
};
</script>

